import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "../site/Reveal";
import { SPECIES, getRange } from "../../data/products";

export const SpeciesSelector = () => {
  const [key, setKey] = useState(SPECIES[0].key);
  const sp = SPECIES.find((s) => s.key === key);
  const r = getRange(sp.range);

  return (
    <section data-testid="species-section" className="bg-[var(--paper)] border-y border-[var(--line)]">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <SectionLabel index="05">Find your solution</SectionLabel>
          <Reveal as="h2" className="font-display text-4xl sm:text-5xl font-light tracking-tight text-[var(--forest)] leading-[1.05] mt-8">
            What are you <span className="italic">feeding?</span>
          </Reveal>
          <div className="mt-10 flex flex-wrap gap-2">
            {SPECIES.map((s) => (
              <button
                key={s.key}
                data-testid={`species-tab-${s.key}`}
                onClick={() => setKey(s.key)}
                className={`rounded-full border px-4 py-2.5 text-sm font-medium transition-[background-color,color,border-color] duration-300 ${key === s.key ? "bg-[var(--forest)] text-[var(--bone)] border-[var(--forest)]" : "border-[var(--line)] hover:border-[var(--forest)]"}`}
              >
                {s.label}
              </button>
            ))}
          </div>
        </div>
        <div className="lg:col-span-7 relative min-h-[360px]">
          <AnimatePresence initial={false}>
            <motion.div
              key={key}
              data-testid="species-result"
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -30, position: "absolute" }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              className="inset-0 w-full rounded-[24px] p-8 md:p-10 grid sm:grid-cols-5 gap-8 items-center"
              style={{ background: r.tint }}
            >
              <div className="sm:col-span-3">
                <p className="eyebrow" style={{ color: r.accent }}>Recommended · {r.name}</p>
                <p className="font-display text-3xl text-[var(--forest)] mt-3">{sp.label}</p>
                <p className="text-[var(--muted)] mt-2">{sp.note}</p>
                <ul className="mt-6 space-y-2">
                  {sp.picks.map((p) => (
                    <li key={p} className="flex items-center gap-3 font-mono text-sm text-[var(--ink)]">
                      <span className="h-2 w-2 rounded-full" style={{ background: r.accent }} />{p}
                    </li>
                  ))}
                </ul>
                <Link to={`/products/${r.slug}`} data-testid="species-result-link" className="mt-8 inline-flex items-center gap-2 font-semibold link-underline" style={{ color: r.accent }}>
                  See {r.name} details <ArrowUpRight size={16} />
                </Link>
              </div>
              <div className="sm:col-span-2 grid place-items-center">
                <img src={r.pack} alt={r.name} className="h-60 w-44 rounded-[10px] object-cover shadow-[0_20px_40px_-25px_rgba(14,42,31,0.6)]" />
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};
